import { Nullable, PartialNullable } from "../../Extensions";
import { PropertyChange } from "../../PropertyChange";
import { Property, PropertyString } from "../../RadObject";
import { IPropertyEditor, PropertyEditor, PropertyEditorPropertyValues } from "../Controls/PropertyEditor";
import { FileUpload } from "./FileUpload";
import { NAMESPACE } from "./_Namespace";

export type PropertyEditorFileUploadPropertyValues =
    PropertyEditorPropertyValues
    & {
        accept: string;
    };

export type PropertyEditorFileUploadProperties = {
    [name in keyof PropertyEditorFileUploadPropertyValues]: Property<PropertyEditorFileUploadPropertyValues[name]>
};

export interface IPropertyEditorFileUpload extends IPropertyEditor, PropertyEditorFileUploadProperties
{
}

export class PropertyEditorFileUpload extends PropertyEditor implements IPropertyEditorFileUpload
{
    // #region Static

    public static override classNamespace = NAMESPACE + "PropertyEditorFileUpload";
    public static override className = "PropertyEditorFileUpload";

    // #region Overrides

    public static override createPropertyDefaults(): PartialNullable<PropertyEditorFileUploadPropertyValues>
    {
        return {
            ...super.createPropertyDefaults(),
            ...{
                createEditorControl: () => new FileUpload(),
            }
        };
    }

    // #endregion

    // #endregion

    // #region Instance

    // #region Properties

    public accept!: PropertyString;

    // #endregion

    // #region Constructor

    constructor(propertyValues?: PartialNullable<PropertyEditorFileUploadPropertyValues>)
    {
        super(propertyValues);

        // Trigger Property Changes
        this.accept.triggerChange();
    }

    // #endregion

    // #region Protected Methods

    protected _acceptChanged(change: PropertyChange<string>)
    {
        (this.editorControl.get() as Nullable<FileUpload>)?.accept.set(change.currentValue);
    }

    // #endregion

    // #region Overrides

    protected override __initializeProperties(propertyValues: PropertyEditorFileUploadPropertyValues)
    {
        super.__initializeProperties(propertyValues);

        this.accept = new PropertyString(this, propertyValues.accept, this._acceptChanged);
    }

    // #endregion

    // #endregion
}

